/**
 * Ref-колбэк: вешает на DOM-узел нативный барьер всплытия pointer-down
 * (`mousedown` / `touchstart`) и возвращает cleanup (React 19 снимает слушатели
 * при отмонтировании узла).
 *
 * Зачем: плавающий слой, живущий в отдельном портале (hover-карточка, лайтбокс
 * аватара рендерятся в `<body>`, вне dropdown-узла родительского попапа/меню), не
 * должен ронять этот попап под собой. Mantine закрывает Popover/Menu нативным
 * document-листенером `mousedown`/`touchstart` (`useClickOutside`), считая «своими»
 * только target и dropdown попапа; клик в чужом портале для него — «снаружи».
 * React-синтетический `stopPropagation` не помогает — слушатель висит на самом
 * `document`. Барьер на узле слоя останавливает событие до `document`, поэтому чужой
 * `useClickOutside` не срабатывает (напр. UserMenu не схлопывается при клике по зуму
 * аватара внутри hover-карточки).
 */
export function stopPointerDownBubble(node: HTMLElement | null): (() => void) | void {
    if (!node) return;
    const stop = (e: Event) => e.stopPropagation();
    node.addEventListener('mousedown', stop);
    node.addEventListener('touchstart', stop);
    return () => {
        node.removeEventListener('mousedown', stop);
        node.removeEventListener('touchstart', stop);
    };
}
